import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createLesson: build.mutation<CreateLessonApiResponse, CreateLessonApiArg>({
      query: (queryArg) => ({
        url: `/v1/bo/courses/${queryArg.id}/lessons`,
        method: "POST",
        body: queryArg.lessonUpdateRequest,
      }),
    }),
    updateLessonById: build.mutation<
      UpdateLessonByIdApiResponse,
      UpdateLessonByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/lessons/${queryArg.id}`,
        method: "PUT",
        body: queryArg.lessonUpdateRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type CreateLessonApiResponse = /** status 200 OK */ SuccessResponse201;
export type CreateLessonApiArg = {
  /** course uuid */
  id: string;
  /** Lecturer update */
  lessonUpdateRequest: LessonUpdateRequest;
};
export type UpdateLessonByIdApiResponse =
  /** status 200 OK */ SuccessResponse200;
export type UpdateLessonByIdApiArg = {
  /** uuid */
  id: string;
  /** Lesson update */
  lessonUpdateRequest: LessonUpdateRequest;
};
export type SuccessResponse201 = {
  id?: string;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse404 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export type EntityLessonStatus = "ls-active" | "ls-preview" | "ls-draft";
export type LessonUpdateRequestTranslation = {
  language: string;
  name: string;
  /** Markdown supported */
  text: string;
};
export type LessonUpdateRequest = {
  isFree: boolean;
  order: number;
  status: EntityLessonStatus;
  titleImageID?: string;
  translations: LessonUpdateRequestTranslation[];
};
export type SuccessResponse200 = {
  status?: string;
};
export const { useCreateLessonMutation, useUpdateLessonByIdMutation } =
  injectedRtkApi;
